import React from 'react';
import { TextField, Typography, MenuItem, Box } from '@mui/material';
import { useField, useFormikContext } from 'formik';

const SelectWrapper = ({
  name,
  label,
  options,
  ...otherProps
}) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);

  const handleChange = evt => {
    const { value } = evt.target;
    setFieldValue(name, value);
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const configSelect = {
    ...field,
    ...otherProps,
    select: true,
    variant: 'outlined',
    fullWidth: true,
    size: "small",
    onChange: handleChange,
    SelectProps: {
      MenuProps: MenuProps,
    }
  };

  if (meta && meta.touched && meta.error) {
    configSelect.error = true;
    configSelect.helperText = meta.error;
  }

  return (
    <Box sx={{ pt: 2 }}>
      <Typography>{label}</Typography>
      <TextField {...configSelect}>
        {options?.map((option) => {
          return (
            <MenuItem key={option.label} value={option.value}>
              {option.label}
            </MenuItem>
          );
        })}
      </TextField>
    </Box>
  );
};

export default SelectWrapper;